import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import styled from 'styled-components';

export const CouponModalWrapper = styled.div`
  width: 450px;
  max-height: 80vh;
  display: flex;
  margin: 14px;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background-color: ${COLORS.white};

  @media ${DEVICES.mobileToTabletXL} {
    width: 70%;
  }

  @media ${DEVICES.mobileXL} {
    min-width: unset;
    width: 95%;
  }
  .close-modal-icon {
    align-self: end;
    justify-self: end;
    display: initial;
    width: 12px;
    height: 12px;
    float: right;
    cursor: pointer;
    margin: 22px 22px 0 0;

    @media ${DEVICES.mobileXL} {
      margin: 50px 22px 0 0;
    }
  }
  .heading {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.black};
  }
  .container-heading {
    font-size: 14px;
    line-height: 22px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.textGrey};
    margin-top: 32px;
    align-self: flex-start;
    padding-left: 16px;
  }
`;

export const InputContainerWrapper = styled.div`
  width: 100%;
  padding: 24px 16px 0 16px !important;
`;

export const InputContainer = styled.div`
  width: 100%;
  padding: 16px;
  height: 88px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  align-items: center;
`;

export const CardsWrapper = styled.div`
  width: 100%;
  padding: 16px;
  max-height: 70%;
  overflow-y: auto;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${COLORS.borderGrey};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.textGrey};
    border-radius: 3px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  gap: 16px;
`;

export const CTAContainer = styled.div`
  margin-top: 12px;
`;

export const CardContainer = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 8px;
  padding: 16px;
  text-align: left;
  margin-bottom: 12px;
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : '')};

  ${CardContent}, ${CTAContainer} {
    opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  }
`;

export const ContentColumn = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;

  @media ${DEVICES.mobileXL} {
    width: 75%;
  }
`;

export const ImageColumn = styled.div`
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${DEVICES.mobileXL} {
    width: 25%;
  }
`;

export const ImageContainer = styled.div`
  width: 54px;
  height: 54px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Heading = styled.h3`
  font-size: 16px;
  line-height: 24px;
  font-family: ${FONT_FAMILY.hellix.bold};
  margin: 0;
  color: ${COLORS.black};
  text-align: left;
`;

export const SubHeading = styled.h4`
  font-size: 14px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
  font-weight: 400;
`;

export const Description = styled.p`
  font-size: 12px;
  line-height: 18px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textLightGrey};
  font-weight: 400;
`;

export const CouponChangeModalContainer = styled.div`
  width: 400px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 32px 16px;
  background-color: ${COLORS.white};
  border-radius: 8px;

  @media ${DEVICES.mobileToTabletXL} {
    width: 400px;
  }

  @media ${DEVICES.mobileXL} {
    min-width: unset;
    width: 280px;
  }
  .heading {
    font-size: 24px;
    line-height: 18px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .description {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    font-family: ${FONT_FAMILY.hellix.regular};
    color: ${COLORS.textGrey};
    margin-top: 12px;
  }
  .got-it-container {
    margin-top: 24px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .secondary-container {
    margin-top: 24px;
  }
`;
